const B2C_REDIRECT_NOTIFICATION_TITLE_KEY = 'B2C_REDIRECT_BANNER_'

export const isB2CBanner = (notificationTitle: string) => notificationTitle.includes(B2C_REDIRECT_NOTIFICATION_TITLE_KEY)

export const cleanB2CRedirectTitle = (title: string) => title.replace(B2C_REDIRECT_NOTIFICATION_TITLE_KEY, '')

export const isBannerAllowed = (isB2CRedirectEnabled: boolean, bannerTitle: string, b2cCookieRedirect: string | undefined) => {
  const isB2CRedirectCookie = Boolean(b2cCookieRedirect)

  if (isB2CRedirectEnabled !== isB2CBanner(bannerTitle)) {
    return false
  }

  if (isB2CBanner(bannerTitle) && !isB2CRedirectCookie) {
    return false
  }

  return true
}
